/** ----------------------------------------
     Map Filter
 ---------------------------------------- */

export class MapFilter {

    constructor(settings) {
        this._settings = settings;
        this._init();
    }

    /** ----------------------------------------
        Coordinates
     ---------------------------------------- */

    _co(value) {
        return `${ value }%`;
    }

    /** ----------------------------------------
         Generate Inputs
     ---------------------------------------- */

    _generate() {
        const layer = document.querySelector('#land');

        this._settings.map(input => {
            const html = this._input(input);
            this._append(layer, html);
        });
    }

    /** ----------------------------------------
         Input Template
     ---------------------------------------- */

    _input(data) {
        const { name, id, short, x, y } = data;

        return ` 
            <div class="map-filter__group" style="top: ${ this._co(y) }; left: ${ this._co(x) }">
                <input type="radio" name="map" value="${ id }" class="form__option map-filter__option" id="${ name }">
                <label for="${ name }">${ short }</label> 
            </div>
        `;
    }

    /** ----------------------------------------
         Append Template
     ---------------------------------------- */

    _append(parent, html) {
        parent.insertAdjacentHTML('beforeend', html);
    }

    /** ----------------------------------------
         Listen
     ---------------------------------------- */

    _listen() {
        const radios = document.querySelectorAll('.map-filter__option');

        [...radios].map(radio => {
            radio.addEventListener('change', () => {
                this._selected(radio.value);
            });
        });
    }

    /** ----------------------------------------
         Selected
     ---------------------------------------- */

    _selected(value, amount = '') {
        const result = document.querySelector('.map-filter__selected');
        const text = document.body.querySelectorAll('.map-filter__name');
        const number = result.querySelector('.map-filter__amount');

        [...text].map(text => text.innerHTML = value);
        number.innerHTML = amount;

        document.querySelector('.map-filter').dispatchEvent(
            new CustomEvent('MapFilterChanged', {
                detail: value
            })
        );
    }

    /** ----------------------------------------
        Initialize
     ---------------------------------------- */

    _init() {
        if(!document.body.querySelector('.map-filter'))
            return;

        this._generate();
        this._listen();
    }

}
